export const HOME = '/';
export const LOGIN = '/login';
export const FB_CALLBACK = '/fb-callback';
export const PASSWORD_RESET = '/password-reset';
export const SET_PASSWORD = '/set-password/:uid/:token';
export const SELECT_SITE = '/select-site';
export const CONNECT_SOCIAL = '/connect-social-account';
export const COMPLETE_PROFILE_STARTSWITH = '/complete-profile';
export const COMPLETE_PROFILE_STEP1 = '/complete-profile/step-1';
export const COMPLETE_PROFILE = '/complete-profile/:step';
export const PROFILE_STATUS = '/profile-status';
export const VIEW_PROFILE = '/view-profile/:uuid';
export const EDIT_PROFILE = '/edit-profile/:section';
export const PRINT_PROFILE = '/view-profile/:uuid/print';
export const ACTIVITIES = '/manage/:type';
export const MANAGE_ACTIVITY_ITEM = '/manage/:type/:slug';
export const DELETE_PROFILE = '/delete-profile';
export const SEARCH_RESULTS = '/search/results';
export const SAVED_SEARCHES = '/search/saved';
export const SEARCH_FORM = '/search/:type';
export const NEWS = '/news';
export const EVENTS = '/events';
export const NEWS_DETAIL = '/news/:slug';
export const EVENT_DETAIL = '/events/:slug';
export const GALLERY = '/gallery';
export const FAQS = '/faqs';
export const GALLERY_DETAIL = '/gallery/:slug';
export const STATIC_PAGES = '/static/:page';
export const TERMS_AND_CONDITION = '/condition/:page';
export const DISCLAIMER_MENU = '/disclaimers';


// WEBPACK FOOTER //
// ./src/config/routes.js